import { useState, type FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import arrowBack from "../../../../assets/images/arrow-back.svg";
import CurrentSteps from "../../../../shared/layout/Steps";
import {
  BackConfirmationModal,
  getItems,
  useNewTrialState,
  useStep,
} from "../../legacy";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import { useTrialsRouter } from "../../../../shared/custom-hooks/useTrialsRouter";
import { RATES_DOSAGE_STEP } from "../../constants";

// Standalone counterpart to the wizard's TrialHeader. This screen is reached
// from the Plot Design step but lives on its own route, so it has to supply
// its own back affordance and stepper instead of inheriting the wizard's
// chrome. The class names are the wizard's on purpose — the layout rules in
// `src/pages/style.less` are shared, not duplicated.
// The header arrow exits setup via confirmation, not browser history.
const PageHeader: FC = () => {
  const { t } = useTranslation();
  const { router } = useTrialsRouter();
  const [isLeaveModalOpen, setIsLeaveModalOpen] = useState(false);
  const { trialProtocolData, trialInfo, newTrialState } = useNewTrialState();
  const isStrip =
    trialProtocolData?.trial_application_method === "strip" ||
    trialInfo?.strip_design?.is_strip === true ||
    !!newTrialState?.stripsData?.isStripMode;
  const steps = useStep(isStrip);

  return (
    <div className="header-main">
      <BackConfirmationModal
        open={isLeaveModalOpen}
        onOk={router.goToTrialsList}
        onCancel={() => {
          setIsLeaveModalOpen(false);
        }}
      />
      <div className="breadcrumbs" data-testid="new-rates-dosage-breadcrumbs">
        <Button
          className="Left-button-icon"
          data-testid="new-rates-dosage-back-btn"
          aria-label={formatTranslation(t("newRatesAndDosage.back"))}
          onClick={() => {
            setIsLeaveModalOpen(true);
          }}
        >
          <img src={arrowBack} alt="left-icon" />
        </Button>
        <p>{formatTranslation(t("trials.edit"))}</p>
      </div>
      <div className="stepper-common" data-testid="new-rates-dosage-stepper">
        <CurrentSteps current={RATES_DOSAGE_STEP} items={getItems(steps)} />
      </div>
    </div>
  );
};

export default PageHeader;
